import { Action, createReducer, on } from '@ngrx/store';
import { ErrorResponse, IGenericError } from 'src/app/core/models/generic-models';
import * as complianceActions from '../actions/static-data-compliance.actions';
import { IStaticDataResponse } from '../models/static-data.model';

export const staticDataMediaRisksFeatureKey = 'staticDataMediaRisks';

export interface StaticDataMediaRisksState {
  loading: boolean;
  data: IStaticDataResponse[];
  error: any;
}

export const initialState: StaticDataMediaRisksState = {
  loading: false,
  data: [],
  error: null
};

export const reducer = createReducer(
  initialState,
  on(complianceActions.loadMediaRisks, state => ({ ...state, loading: true, error: null })),
  on(complianceActions.loadMediaRisksSuccess, (state, { response }) => ({ ...state, loading: false, data: response, error: null })),
  on(complianceActions.loadMediaRisksFailure, (state, { error }) => ({ ...state, loading: false, error }))
);

export const getMediaRisks = (state: StaticDataMediaRisksState) => state.data;
export const getMediaRisksLoading = (state: StaticDataMediaRisksState) => state.loading;
export const getMediaRisksError = (state: StaticDataMediaRisksState) => state.error;